import {
  SectionElement,
  defineElement,
  on
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/shop-customer-logos/shop-customer-logos.ts
var ShopCustomerLogos = class extends SectionElement {
  connectedCallback() {
    return __async(this, null, function* () {
      console.log("init section ShopCustomerLogos");
    });
  }
  handleClick() {
    console.log("clicked");
  }
};
__decorateClass([
  on("click")
], ShopCustomerLogos.prototype, "handleClick", 1);
ShopCustomerLogos = __decorateClass([
  defineElement("shop-customer-logos")
], ShopCustomerLogos);
export {
  ShopCustomerLogos
};
